export default {
  form: {
    app: "APP",
    userId: "用户ID",
    creator: "创建人",
    utr: "UTR",
    action: "操作",
    examine: "审核",
    state: "状态",
    createTime: "创建时间",
    processTime: "处理时间",
    assign: "分配",
    orderType: "订单类型",
    defaultOrder: "普通订单",
    largeOrder: "大额订单",
    problemOrder: "疑难订单",
    largeIssueOrder: "疑难大额",
  },
  table: {
    app: "APP",
    userId: "用户ID",
    creator: "创建人",
    uploadImage: "图片",
    utr: "UTR",
    amount: "金额",
    payTime: "支付时间",
    processTime: "处理时间",
    pdf: "PDF",
    video: "视频",
    action: "操作",
    remark: "备注",
    orderNo: "订单号",
    channelName: "渠道名称",
    relationType: "订单类型",
    adminUsername: "后台用户名",
    imageStatus: "图片材料状态",
    pdfStatus: "PDF材料状态",
    videoStatus: "视频材料状态",
    orderStatus: "订单状态",
    l1Remark: "L1客服备注",
    l2Remark: "L2客服备注",
    createTime: "创建时间",
    view: "查看",
    assignTime: "分配时间",
    operator: "操作人",
    assigner: "分配人",
    grade: "VIP等级",
    orderType: "订单类型",
    cancelAt: "自动成功时间",
  },
  paymentStatus: {
    pendingReview: "待审核",
    failed: "付款失败",
    success: "付款成功",
    refunded: "付款回退",
    pending: "付款等待",
    fakeProof: "虚假证明",
  },
  common: {
    success: "成功",
    failed: "失败",
    processing: "处理中",
    withdraw: "提现",
    deposit: "充值",
    invalidPreviewLink: "无效的预览链接",
    selectItem: "请选择列表项",
    currentVersion: "当前版本",
    historyRecord: "历史记录",
    viewPDF: "查看PDF",
    openInNewWindow: "在新窗口打开",
  },
  validate: {
    select: "请选择",
    input: "请输入",
  },
  result: {
    success: "审核成功",
  },
};
